import * as React from 'react';

interface IWithChangeOrienatationProps {
  children: React.JSX.Element;
  handler(): void;
}

export const WithChangeOrientation = (props: IWithChangeOrienatationProps): React.JSX.Element => {
  const handler = React.useCallback(() => {
    props.handler();
  }, [props]);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: portrait)');

    mediaQuery.addListener(handler);

    return () => mediaQuery.removeListener(handler);
  }, [handler]);

  React.useEffect(() => {
    handler();
  }, [handler]);

  return props.children;
};
